import { hubbleAPI } from './url'
const resource = hubbleAPI + 'public/ct/products'
export default ($axios) => ({
  getAll () {
    return $axios.get(`${resource}/family`)
  },

  getFamilyByCategory (categoryId) {
    return $axios.get(`${resource}/family/${categoryId}`)
  },

  getFamilyByCategorySlug (slug) {
    return $axios.get(`${resource}/family/slug/${slug}`)
  },

  getProductDetails (categorySlug, productSlug) {
    return $axios.get(`${hubbleAPI}public/ct/product-details/${categorySlug}/${productSlug}`)
  },

  getProductsGroupedBySubscriptions (categoryId) {
    return $axios.get(`${hubbleAPI}public/ct/products/family/grouped-by-subscriptions/${categoryId}`)
  },

  getProductsGroupedBySubscription (categoryId, subscriptionId) {
    return $axios.get(`${hubbleAPI}public/ct/products/family/grouped-by-subscription/${categoryId}/${subscriptionId}`)
  }


})
